var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _g, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityIconSuperadmin1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 229,
    viewBox: "0 0 278 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1781_2856)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.956 0.472772C199.623 2.26027 190.13 8.84032 184.321 17.8944C181.601 22.1364 176.686 24.4356 171.706 23.6713C169.647 23.354 167.516 23.3022 165.347 23.5353C158.884 24.2348 153.276 27.3823 149.352 31.9547C147.079 34.6035 143.368 35.3548 140.182 33.93C129.575 29.1828 116.144 37.0516 116.733 49.9138C117.122 58.4238 123.856 65.4572 132.366 65.9365C135.714 66.1243 138.815 65.3601 141.458 63.9094C144.456 62.2644 148.16 62.912 150.576 65.3342C155.659 70.4311 162.918 73.2613 170.638 72.4324C174.102 72.0567 177.314 70.9816 180.157 69.3625C184.476 66.9015 189.871 67.0828 193.866 70.0555C201.443 75.6965 211.085 78.6044 221.22 77.5099C241.476 75.3208 256.41 57.9316 255.898 37.9195C255.302 14.5979 234.003 -3.15403 210.962 0.479248L210.956 0.472772Z",
    fill: "#E4F2F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5199 59.2981C65.9691 53.1325 56.3914 49.3697 45.9329 49.169C21.2731 48.7027 0.595797 68.4817 0.0129745 93.1374C-0.5828 118.525 19.8095 139.288 45.0587 139.288C48.4391 139.288 51.7288 138.913 54.8955 138.207C63.1197 136.368 71.6613 136.802 79.646 139.509C84.2762 141.076 89.3079 141.937 94.5727 141.937C117.51 141.937 136.102 125.61 136.102 105.475C136.102 85.3398 118.805 70.6318 98.0438 69.1164C89.0683 68.4622 80.4943 64.9844 73.5199 59.2916V59.2981Z",
    fill: "#C8E6EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.377 154.178C146.774 145.273 145.952 135.888 140.544 133.22C138.071 132.002 136.406 129.58 136.147 126.834C134.852 113.111 128.202 102.645 119.524 102.081C112.116 101.596 105.232 108.454 101.457 118.829C100.375 121.802 98.1344 124.211 95.2397 125.494C88.1423 128.641 86.1736 139.729 90.8427 150.253C91.1211 150.875 90.9851 151.607 90.4994 152.086C88.3106 154.268 86.8795 157.222 86.6593 160.551C86.4326 164.009 87.5594 167.241 89.5864 169.734C91.5679 172.169 92.5523 175.265 92.3451 178.393C91.8658 185.66 97.3767 191.942 104.643 192.421C106.611 192.551 108.502 192.24 110.225 191.579C113.132 190.459 116.267 189.979 119.369 190.18C127.651 190.724 134.8 184.449 135.344 176.172C135.37 175.764 135.377 175.356 135.37 174.948C139.23 172.862 141.963 168.899 142.274 164.203C142.371 162.688 142.209 161.224 141.833 159.838C141.315 157.954 141.503 155.939 142.371 154.184L142.377 154.178Z",
    fill: "#39AE96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.128 155.259C120.275 156.438 117.121 159.216 115.47 162.895L114.764 164.469L114.991 122.612L113.126 122.599L112.977 149.748L112.213 148.019C110.302 143.712 106.929 140.182 102.706 138.09L102.013 139.483C105.912 141.413 109.027 144.67 110.788 148.647C112.213 151.671 112.945 154.974 112.925 158.316L112.796 182.564L111.216 179.921C109.202 176.554 106.249 173.905 102.68 172.266L102.033 173.678C105.316 175.187 108.029 177.622 109.882 180.725C111.772 183.892 112.763 187.518 112.744 191.21L112.621 214.357H114.486L114.706 173.536C114.725 170.084 115.464 166.677 116.882 163.53C118.352 160.266 121.156 157.792 124.582 156.742L124.128 155.259Z",
    fill: "#177D74"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.449 202.796H127.658V213.152C127.658 220.205 121.933 225.937 114.874 225.937H112.232C105.18 225.937 99.449 220.211 99.449 213.152V202.796Z",
    fill: "#B48255"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.658 206.281H99.449V210.173H127.658V206.281Z",
    fill: "#A56941"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.658 206.281H99.449V207.349H127.658V206.281Z",
    fill: "#DCBE82"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M257.342 20.1935H150.919C146.191 20.1935 142.358 24.0267 142.358 28.7553V217.368C142.358 222.097 146.191 225.93 150.919 225.93H257.342C262.07 225.93 265.903 222.097 265.903 217.368V28.7553C265.903 24.0267 262.07 20.1935 257.342 20.1935Z",
    fill: "#5046AF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M249.267 20.1935H142.843C138.115 20.1935 134.282 24.0267 134.282 28.7553V217.368C134.282 222.097 138.115 225.93 142.843 225.93H249.267C253.995 225.93 257.828 222.097 257.828 217.368V28.7553C257.828 24.0267 253.995 20.1935 249.267 20.1935Z",
    fill: "#6E64C3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M247.285 28.574H144.028V205.562H247.285V28.574Z",
    fill: "#32285F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M247.285 28.574H144.028V32.4274H247.285V28.574Z",
    fill: "#1E1632"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M175.695 220.315H158.34C155.633 220.315 153.444 218.12 153.444 215.419C153.444 212.712 155.64 210.523 158.34 210.523H175.695C178.402 210.523 180.591 212.718 180.591 215.419C180.591 218.126 178.396 220.315 175.695 220.315Z",
    fill: "#41378C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M231.963 220.315H214.608C211.901 220.315 209.713 218.12 209.713 215.419C209.713 212.712 211.908 210.523 214.608 210.523H231.963C234.67 210.523 236.859 212.718 236.859 215.419C236.859 218.126 234.664 220.315 231.963 220.315Z",
    fill: "#41378C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M207.653 25.9445H183.434C182.825 25.9445 182.333 25.4523 182.333 24.8435C182.333 24.2348 182.825 23.7426 183.434 23.7426H207.653C208.262 23.7426 208.754 24.2348 208.754 24.8435C208.754 25.4523 208.262 25.9445 207.653 25.9445Z",
    fill: "#5046AF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M247.292 80.7222L143.983 126.232V155.318L247.292 109.808V80.7222Z",
    fill: "#41378C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M247.292 115.954L143.983 161.464V186.877L247.292 141.367V115.954Z",
    fill: "#41378C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M230.986 38.4247H129.497V201.346H230.986V38.4247Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M228.784 36.2227H127.295V199.144H228.784V36.2227Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M150.543 81.4087H138.433C137.146 81.4087 136.102 82.4525 136.102 83.7402V95.8511C136.102 97.1388 137.146 98.1826 138.433 98.1826H150.543C151.831 98.1826 152.874 97.1388 152.874 95.8511V83.7402C152.874 82.4525 151.831 81.4087 150.543 81.4087Z",
    stroke: "#B4D7DC",
    strokeWidth: 3.4,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M163.372 81.4087H188.576",
    stroke: "#B4D7DC",
    strokeWidth: 3.4,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M163.372 90.5988H217.445",
    stroke: "#B4D7DC",
    strokeWidth: 3.4,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M163.009 97.4508H217.076",
    stroke: "#B4D7DC",
    strokeWidth: 3.4,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M150.543 50.4644H138.433C137.146 50.4644 136.102 51.5082 136.102 52.7959V64.9068C136.102 66.1945 137.146 67.2383 138.433 67.2383H150.543C151.831 67.2383 152.874 66.1945 152.874 64.9068V52.7959C152.874 51.5082 151.831 50.4644 150.543 50.4644Z",
    stroke: "#B4D7DC",
    strokeWidth: 3.4,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M163.372 50.4644H188.576",
    stroke: "#B4D7DC",
    strokeWidth: 3.4,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M163.372 59.6544H217.445",
    stroke: "#B4D7DC",
    strokeWidth: 3.4,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M163.009 66.5065H217.076",
    stroke: "#B4D7DC",
    strokeWidth: 3.4,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M150.543 112.353H138.433C137.146 112.353 136.102 113.397 136.102 114.685V126.795C136.102 128.083 137.146 129.127 138.433 129.127H150.543C151.831 129.127 152.874 128.083 152.874 126.795V114.685C152.874 113.397 151.831 112.353 150.543 112.353Z",
    stroke: "#B4D7DC",
    strokeWidth: 3.4,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M163.372 112.599H188.576",
    stroke: "#B4D7DC",
    strokeWidth: 3.4,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M163.372 121.789H217.445",
    stroke: "#B4D7DC",
    strokeWidth: 3.4,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M163.009 128.641H217.076",
    stroke: "#B4D7DC",
    strokeWidth: 3.4,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M150.543 143.297H138.433C137.146 143.297 136.102 144.341 136.102 145.629V157.74C136.102 159.027 137.146 160.071 138.433 160.071H150.543C151.831 160.071 152.874 159.027 152.874 157.74V145.629C152.874 144.341 151.831 143.297 150.543 143.297Z",
    stroke: "#B4D7DC",
    strokeWidth: 3.4,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M163.372 143.79H188.576",
    stroke: "#B4D7DC",
    strokeWidth: 3.4,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M163.372 152.98H217.445",
    stroke: "#B4D7DC",
    strokeWidth: 3.4,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M163.009 159.825H217.076",
    stroke: "#B4D7DC",
    strokeWidth: 3.4,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M180.442 176.645C180.442 179.196 178.376 181.262 175.825 181.262C173.273 181.262 171.207 179.196 171.207 176.645C171.207 174.093 173.273 172.027 175.825 172.027C178.376 172.027 180.442 174.093 180.442 176.645Z",
    fill: "#B4D7DC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M196.359 176.645C196.359 179.196 194.294 181.262 191.742 181.262C189.191 181.262 187.125 179.196 187.125 176.645C187.125 174.093 189.191 172.027 191.742 172.027C194.294 172.027 196.359 174.093 196.359 176.645Z",
    fill: "#B4D7DC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M212.277 176.645C212.277 179.196 210.211 181.262 207.66 181.262C205.108 181.262 203.043 179.196 203.043 176.645C203.043 174.093 205.108 172.027 207.66 172.027C210.211 172.027 212.277 174.093 212.277 176.645Z",
    fill: "#B4D7DC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M164.524 176.645C164.524 179.196 162.459 181.262 159.907 181.262C157.356 181.262 155.29 179.196 155.29 176.645C155.29 174.093 157.356 172.027 159.907 172.027C162.459 172.027 164.524 174.093 164.524 176.645Z",
    fill: "#B4D7DC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M148.607 176.645C148.607 179.196 146.541 181.262 143.99 181.262C141.438 181.262 139.372 179.196 139.372 176.645C139.372 174.093 141.438 172.027 143.99 172.027C146.541 172.027 148.607 174.093 148.607 176.645Z",
    fill: "#B4D7DC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0038 110.462C77.0038 110.462 103.801 115.339 105.977 86.5834",
    stroke: "#F9C388",
    strokeWidth: 11.84,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4531 220.678H76.1814V175.615H69.4531V220.678Z",
    fill: "#F9C388"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6245 220.678H63.3528L63.3528 175.615H56.6245L56.6245 220.678Z",
    fill: "#F9C388"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4531 220.678H76.1814V210.186H69.4531V220.678Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6245 220.678H63.3528V210.186H56.6245V220.678Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4531 213.165H76.1814V211.65H69.4531V213.165Z",
    fill: "#5AA7E0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6245 213.165H63.3528V211.65H56.6245V213.165Z",
    fill: "#5AA7E0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4531 214.972H76.1814V214.376H69.4531V214.972Z",
    fill: "#408DBC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6245 214.972H63.3528V214.376H56.6245V214.972Z",
    fill: "#408DBC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6528 217.835H78.6228L78.6228 147.565H67.6528L67.6528 217.835Z",
    fill: "#3C142D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8307 217.841H65.8007V156.166L54.8307 147.572V217.841Z",
    fill: "#3C142D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8307 171.178H78.6228V147.565H54.8307V171.178Z",
    fill: "#3C142D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6528 220.198H79.9698V216.721H67.6528V220.198Z",
    fill: "#50374B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6753 220.198H67.8924V216.721H54.6753V220.198Z",
    fill: "#695A6E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M68.132 225.93H89.0942V224.564H68.132V225.93Z",
    fill: "#2B2E2F"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2452 224.564H53.283V225.93H74.2452V224.564Z",
    fill: "#434749"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7667 224.564H68.6436V220.03H84.3474C86.2319 220.03 87.7602 221.559 87.7602 223.443V224.564H87.7667Z",
    fill: "#132736"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3256 224.564H54.2025V220.03H69.9064C71.7908 220.03 73.3191 221.559 73.3191 223.443V224.564H73.3256Z",
    fill: "#172F40"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0669 155.013H53.8528V112.01C53.8528 108.765 56.482 106.136 59.7264 106.136H80.0669V155.013Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8593 112.165C53.8593 108.836 56.223 106.136 59.1436 106.136H66.4418V149.372C66.4418 156.322 60.8079 161.95 53.8658 161.95V112.165H53.8593Z",
    fill: "#50374B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3771 105.773L69.4466 124.393L66.3253 151.004L64.5768 118.447L66.4353 116.861L63.3529 114.147L62.7441 106.395L66.3771 105.773Z",
    fill: "#695A6E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M57.57 110.462C57.57 118.59 55.964 130.675 50.3753 133.382C43.9772 136.478 36.2451 135.791 30.1838 115.507",
    stroke: "#F9C388",
    strokeWidth: 11.84,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8651 110.579C82.4759 111.116 104.034 112.249 105.977 86.5769",
    stroke: "#50374B",
    strokeWidth: 12.47,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M57.57 110.462C57.57 118.59 55.964 130.675 50.3753 133.382C43.9772 136.478 36.2451 135.791 30.1838 115.507",
    stroke: "#50374B",
    strokeWidth: 12.47,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7145 111.317V160.628C76.5829 158.569 73.7401 154.301 73.7401 149.366L73.5134 117.372L74.1351 106.136H75.5339C78.3962 106.136 80.7145 108.454 80.7145 111.317Z",
    fill: "#50374B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0379 105.242L70.7288 124.393L73.8501 151.004L75.5986 118.447L73.74 116.861L76.829 114.147L77.5737 106.291L74.0379 105.242Z",
    fill: "#695A6E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4657 139.055H76.2721V146.238C76.2721 149.295 78.5322 151.82 81.4657 152.254V139.055Z",
    fill: "#695A6E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M126.215 66.6617L21.8048 111.308L26.6089 122.545L131.019 77.8986L126.215 66.6617Z",
    fill: "#E4F2F6"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M131.012 77.9179L134.218 76.5449C137.32 75.2172 138.764 71.6293 137.436 68.5206C136.109 65.4184 132.521 63.9741 129.413 65.3018L126.207 66.6748L131.012 77.9114V77.9179Z",
    fill: "#55C7A6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M128.168 71.2384L23.7583 115.885L26.6097 122.555L131.02 77.908L128.168 71.2384Z",
    fill: "#C8E6EB"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M130.201 75.9955L25.7911 120.642L26.6083 122.554L131.018 77.907L130.201 75.9955Z",
    fill: "#B4D7DC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7823 121.193C28.0273 121.945 25.9939 121.129 25.2427 119.374L21.7976 111.317L15.1081 114.179C13.3726 114.924 12.5696 116.932 13.3078 118.668L16.727 126.666C17.4717 128.402 19.4792 129.205 21.2148 128.466L62.0577 111.006C63.7349 110.287 64.5185 108.344 63.7997 106.667L29.7823 121.213V121.193Z",
    fill: "#6C9BAA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3753 133.382C43.9772 136.478 36.2451 135.791 30.1838 115.507",
    stroke: "#F9C388",
    strokeWidth: 11.84,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0082 131.62C53.0369 129.613 50.6214 128.771 48.6139 129.742C45.7581 131.122 44.1844 130.733 43.2454 130.319C41.6459 129.613 38.7577 127.242 35.7594 119.406L28.5389 123.091C31.6473 130.882 35.4162 135.694 39.9946 137.708C41.62 138.427 43.3167 138.783 45.0716 138.783C47.3317 138.783 49.6954 138.194 52.1367 137.009C54.1442 136.037 54.9861 133.622 54.0147 131.614L54.0082 131.62Z",
    fill: "#50374B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0628 139.055H62.0188V147.06C62.0188 149.929 59.6876 152.254 56.8252 152.254H53.0628V139.055Z",
    fill: "#695A6E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0424 110.579C72.0305 110.579 73.6494 108.966 73.6494 106.971V98.7267H66.4418V106.971C66.4418 108.959 68.0543 110.579 70.0489 110.579H70.0424Z",
    fill: "#DD9F6B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0233 90.0094C77.0233 92.03 78.6617 93.6621 80.6756 93.6621C82.6896 93.6621 84.328 92.0236 84.328 90.0094C84.328 87.9952 82.6896 86.3567 80.6756 86.3567C78.6617 86.3567 77.0233 87.9952 77.0233 90.0094Z",
    fill: "#DD9F6B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1 104.452H70.1265C63.5277 104.452 58.1722 99.0958 58.1722 92.4963V75.5734H82.8127V96.7384C82.8127 100.993 79.3546 104.452 75.1 104.452Z",
    fill: "#F2B47C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6811 94.4133C79.0502 94.4133 79.2704 94.8796 79.0826 95.2358C78.2861 96.7578 76.829 97.7681 75.1712 97.7616C73.5134 97.7551 72.0628 96.7254 71.2793 95.197C71.0915 94.8343 71.3181 94.3745 71.6872 94.3809L78.6876 94.4198L78.6811 94.4133Z",
    fill: "#654932"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1781_2856",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 94,
    width: 9,
    height: 4
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6811 94.4133C79.0502 94.4133 79.2704 94.8796 79.0826 95.2358C78.2861 96.7578 76.829 97.7681 75.1712 97.7616C73.5134 97.7551 72.0628 96.7254 71.2793 95.197C71.0915 94.8343 71.3181 94.3745 71.6872 94.3809L78.6876 94.4198L78.6811 94.4133Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1781_2856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.9851 99.1541C71.9851 101.175 73.4163 102.813 75.1842 102.813C76.952 102.813 78.3832 101.175 78.3832 99.1541C78.3832 97.1334 76.952 95.4949 75.1842 95.4949C73.4163 95.4949 71.9851 97.1334 71.9851 99.1541Z",
    fill: "#D34C4C"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8525 77.5358C84.8525 76.0074 84.2373 74.6279 83.2401 73.624C82.7608 69.4597 78.1825 67.4131 72.2959 67.0505L72.8075 66.6036C72.9694 66.4611 72.9889 66.2085 72.8464 66.0466C72.7039 65.8847 72.4514 65.8653 72.2895 66.0077L71.6548 66.5647V65.8005C71.6548 65.3601 71.2987 65.0104 70.8648 65.0104C70.4309 65.0104 70.0747 65.3666 70.0747 65.8005V66.5064L69.4984 65.9689C69.3365 65.8199 69.0904 65.8264 68.9415 65.9883C68.7925 66.1502 68.799 66.3963 68.9609 66.5453L69.4531 67.0051C62.919 67.1865 57.7318 69.3237 57.4469 73.9543C56.631 74.9193 56.1323 76.1693 56.1323 77.5293C56.1323 80.5862 58.6126 83.0731 61.6756 83.0731V90.6117C61.6756 91.2529 62.2002 91.7775 62.8413 91.7775H63.4306C64.0717 91.7775 64.5962 91.2529 64.5962 90.6117V82.6651C66.3317 83.2869 68.2874 83.6495 70.3662 83.6495C72.6845 83.6495 74.8604 83.2027 76.7448 82.4384C77.5154 82.8465 78.3962 83.0796 79.3351 83.0796C80.0086 83.0796 80.6562 82.9501 81.252 82.7299V85.1909C81.252 85.8321 81.7765 86.3567 82.4176 86.3567H83.0069C83.648 86.3567 84.1726 85.8321 84.1726 85.1909V80.23C84.6194 79.4334 84.872 78.5137 84.872 77.5358H84.8525Z",
    fill: "#422505"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1613 93.3512H60.8467C58.5413 93.3512 56.6698 91.4795 56.6698 89.1739V78.423H62.1613V93.3512Z",
    fill: "#422505"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7792 86.3567C61.9347 86.3567 62.0901 86.3696 62.239 86.3891V93.6362C62.0901 93.6556 61.9347 93.6686 61.7792 93.6686C59.7588 93.6686 58.1269 92.03 58.1269 90.0159C58.1269 88.0017 59.7653 86.3632 61.7792 86.3632V86.3567Z",
    fill: "#F2B47C"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4102 88.1442C81.1031 88.1442 81.7571 88.6105 82.1522 89.3876C82.2428 89.5625 82.2104 89.8151 82.0874 89.9381C81.9579 90.0677 81.783 90.0223 81.6924 89.8475C81.401 89.2711 80.9282 88.9343 80.4102 88.9343C79.8921 88.9343 79.4194 89.2646 79.128 89.8475C79.0697 89.9576 78.9855 90.0159 78.9013 90.0159C78.843 90.0159 78.7847 89.9899 78.7394 89.9446C78.6099 89.8151 78.584 89.569 78.6746 89.3941C79.0697 88.6169 79.7237 88.1506 80.4166 88.1506L80.4102 88.1442Z",
    fill: "#654932"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5039 89.3876C68.0608 88.6105 68.9739 88.1442 69.9517 88.1442C70.9296 88.1442 71.8427 88.6105 72.3996 89.3876C72.5291 89.5625 72.4838 89.8151 72.3089 89.9381C72.1341 90.0677 71.8815 90.0223 71.7585 89.8475C71.344 89.2711 70.69 88.9343 69.9582 88.9343C69.2264 88.9343 68.5724 89.2646 68.1579 89.8475C68.0802 89.9576 67.9572 90.0159 67.8341 90.0159C67.7564 90.0159 67.6722 89.9899 67.6075 89.9446C67.4326 89.8151 67.3873 89.569 67.5168 89.3941L67.5039 89.3876Z",
    fill: "#654932"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M149.248 87.7427L143.705 93.2865L140.596 90.1843",
    stroke: "#3C5A73",
    strokeWidth: 3.84,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M149.248 118.804L143.705 124.354L140.596 121.245",
    stroke: "#3C5A73",
    strokeWidth: 3.84,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M149.248 149.249L143.705 154.793L140.596 151.684",
    stroke: "#3C5A73",
    strokeWidth: 3.84,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M276.465 229H44.437C43.5887 229 42.9022 228.313 42.9022 227.465C42.9022 226.617 43.5887 225.93 44.437 225.93H276.465C277.314 225.93 278 226.617 278 227.465C278 228.313 277.314 229 276.465 229Z",
    fill: "#C8E6EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1781_2856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 278,
    height: 229,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIconSuperadmin1);
export default __webpack_public_path__ + "static/media/activity_icon_superadmin1.7dd4b1fcf5edf54599713aa18fccf7e7.svg";
export { ForwardRef as ReactComponent };